import React from 'react';

const AdminSettings = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">Configure application settings</p>
      </div>
      <div className="flex h-[400px] items-center justify-center rounded-lg border border-dashed border-border bg-card">
        <p className="text-muted-foreground">Settings page coming soon...</p>
      </div>
    </div>
  );
};

export default AdminSettings;

